import { PageHeader } from '../components/states';
import { BetsTable } from '../components/BetsTable';

export function BetsPage() {
  return (
    <div className="page">
      <PageHeader title="Lịch sử cược" lead="Mọi ván và vé cược: game, Lô đề, Keno, Live Casino. Mới nhất trước. Lệnh cược của ván đang mở hiện ngay (Chờ kết quả ván); trang tự cập nhật 2 giây một lần, 15 giây khi lọc theo trạng thái, số tiền, phiên, ngày hoặc nhà cung cấp live." />
      <BetsTable />
    </div>
  );
}
